import { useState, useCallback } from 'react';
import {
    trackEvent,
    eventNameConstants,
    interactionTypeConstants,
    stepInteractionConstants,
} from 'dibs-tracking';
const { EVENT_PRODUCT_INTERACTION } = eventNameConstants;
const { INTERACTION_TYPE_PDP } = interactionTypeConstants;
const { STEP_INTERACTION_PDP_MODULE_ARROW_CLICK } = stepInteractionConstants;

const ITEMS_REFETCH_LIMIT = 4;

type PaginationHooks = {
    onClickArrow: (direction: string) => void;
    onCarouselReset: () => void;
};

export const usePaginationHooks = (
    loadNext: (count: number) => void,
    options?: { itemsRefetchLimit?: number; label?: string; action?: string; category?: string }
): PaginationHooks => {
    const {
        itemsRefetchLimit = ITEMS_REFETCH_LIMIT,
        label = 'pdp carousel',
        action = 'pdp module arrow click',
        category = 'product',
    } = options || {};
    const [hasFetchedAllImages, setHasFetchedAllImages] = useState(false);
    const onClickArrow = useCallback(() => {
        if (!hasFetchedAllImages) {
            setHasFetchedAllImages(true);
            loadNext(itemsRefetchLimit);
        }
        trackEvent(
            {
                label,
                category,
                isInteractiveEvent: true,
                action,
                eventName: EVENT_PRODUCT_INTERACTION,
                interaction_type: INTERACTION_TYPE_PDP,
                step_interaction_name: STEP_INTERACTION_PDP_MODULE_ARROW_CLICK,
                trigger: label,
            },
            null
        );
    }, [hasFetchedAllImages, itemsRefetchLimit, loadNext, label, action, category]);

    const onCarouselReset = useCallback(() => {
        setHasFetchedAllImages(false);
    }, []);

    return {
        onClickArrow,
        onCarouselReset,
    };
};
